import HtmlTrans from 'components/shared/HtmlTrans';
import {
  StyledBillboard,
  StyledBillboardContent,
  StyledBillboardTitle,
  StyledContainer
} from './DurationAndCosts.styled';
import Fees from './Fees';
import Stages from './Stages';
import TimeToHire from './TimeToHire';

const DurationAndCosts: React.FC = () => {
  return (
    <div>
      <StyledBillboard>
        <StyledContainer>
          <StyledBillboardContent>
            <StyledBillboardTitle as="p">
              <HtmlTrans
                ns="state-of-hiring"
                i18nKey="state-of-hiring.time-to-hire.billboard-title"
              />
            </StyledBillboardTitle>
            <p>
              <HtmlTrans
                ns="state-of-hiring"
                i18nKey="state-of-hiring.time-to-hire.billboard-desc"
              />
            </p>
          </StyledBillboardContent>
        </StyledContainer>
      </StyledBillboard>
      <TimeToHire />
      <Stages />
      <Fees />
    </div>
  );
};

export default DurationAndCosts;
